import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {Referent} from './referent.model';

@Injectable()
export class ReferentService {

    private resourceUrl = 'api/referents';
    private resourcePublicUrl = 'api/public/referents';
    private resourceRecommandationUrl = 'api/public/recommandation';
    private resourceRecommandationDownloadUrl = 'api/public/recommandation/download';

    constructor(private http: Http) { }

    create(referent: Referent): Observable<Referent> {
        let copy: Referent = Object.assign({}, referent);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(referent: Referent, referentKey: String): Observable<Referent> {
        let params = new URLSearchParams();
        if (referentKey != null) {
            params.set('referentKey', referentKey.toString());
        }
        let copy: Referent = Object.assign({}, referent);
        return this.http.put(this.resourcePublicUrl, copy, {search: params}).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Referent> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            return res.json();
        });
    }

    get(key: string): Observable<any> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('key', key);

        return this.http.get(this.resourceRecommandationUrl, {
            search: params
        }).map((res: Response) => res);
    }

    /*    openFile(name: string): Observable<any> {
            return this.http.get(`${this.resourceRecommandationDownloadUrl}/${name}`, { responseType: ResponseContentType.Blob }).map(
                (res) => {
                    return new Blob([res.blob()], { type: 'application/pdf' });
                });
        }*/

    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req.candidatureFormationId) {
            params.set('candidatureFormationId', req.candidatureFormationId);
        }
        return this.http.get(this.resourceUrl, { search: params });
    }

    /*    delete(id: number): Observable<Response> {
            return this.http.delete(`${this.resourceUrl}/${id}`);
        }*/


    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/referent/referent.service.ts